export default __webpack_public_path__ + "static/media/Happy Users-icon.28bfc70d.svg";